import HtmlEditor from "./HtmlEditor.presenter";

export default HtmlEditor;
